import React from 'react';
import '@/components/container/service/etc/PageLoading.css';
import LottieToGif from '@/components/common/loading/LottieToGif';
import animationData from '@/components/common/loading/animaion.json';

interface PageLoadingProps {
    isOverlay ?: boolean
}

/**  페이지 로딩  **/
const PageLoading = ({ isOverlay }: PageLoadingProps) => {

    return (
        <div className={`page-loading ${isOverlay && 'overlay'}`}>
            <LottieToGif animationData={animationData} />
        </div>
    );

};

export default PageLoading;
